module.exports = require("@swissquote/crafty/packages/anymatch.js");